import _ from "lodash";
import { singleton } from "./singleton";

/**
 * 缓存
 * Created by slipkinem on 2018/9/25 at 下午5:12.
 */
@singleton
class Cache {
  private cache = new Map();

  set<T>(key: string, value: T) {
    return this.cache.set(key, _.cloneDeep(value));
  }

  get<T>(key: string): T {
    return _.cloneDeep(this.cache.get(key));
  }

  remove(key: string) {
    return this.cache.delete(key);
  }
}

export const cache = new Cache();
